import { Type } from "class-transformer";
import FuelTypeLimitationResponse from "entities/fuelTypeLimitationResponse";
import { observable } from "mobx";
import "reflect-metadata";
import { EntityValidationRules } from "services/validationService";

export const FuelTypeValidationRules: EntityValidationRules<ChargeOrderFuelItem> = {
  fuelTypeId: { required: true },
};

export default class ChargeOrderFuelItem {
  @observable fuelTypeId?: string;

  @observable
  @Type(() => FuelTypeLimitationResponse)
  _fuelTypeLimitation?: FuelTypeLimitationResponse;

  @observable
  _fuelTypeLimitationOrder?: string[];

  constructor(_fuelTypeLimitation?: FuelTypeLimitationResponse | undefined, fuelTypeId?: string | undefined) {
    this._fuelTypeLimitation = _fuelTypeLimitation;
    this.fuelTypeId = fuelTypeId;
  }
}
